import { ShadowClass } from "../../ui/shadow/shadow";

class HeaderClass {
  init() {
    const header = document.querySelector(".header");
    const headerHamburger = document.querySelector(".header__hamburger");
    const headerOpenImg = document.querySelector(".header__hamburger-img");
    const headerCloseImg = document.querySelector(".header__close-img");
    const headerTop = document.querySelector(".header-top");
    const headerPlug = document.querySelector(".header-plug");
    const shadowElement = document.querySelector(".shadow");

    const mobileDropdownLinks = document.querySelectorAll(
      ".header__mobile-dropdown__link"
    );
    const mobileDropdownButton = document.querySelector(
      ".header__mobile-dropdown__button"
    );
    const mobileDropdownAuthLink = document.querySelector(
      ".header-top__auth-link_dropdown"
    );

    const isDesktop = window.innerWidth > 1160;

    if (isDesktop) {
      mobileDropdownLinks.forEach((link) => {
        link.setAttribute("tabindex", "-1");
      });
      mobileDropdownButton.setAttribute("tabindex", "-1");
      mobileDropdownAuthLink.setAttribute("tabindex", "-1");
    }

    const Shadow = new ShadowClass(shadowElement);

    headerHamburger.addEventListener("click", () => {
      if (!header.classList.contains("header_expanded")) {
        header.classList.add("header_expanded");
        headerOpenImg.classList.remove("header__hamburger-img_visible");
        headerCloseImg.classList.add("header__close-img_visible");
        headerHamburger.setAttribute("aria-expanded", true);

        if (window.scrollY === 0) {
          headerPlug.classList.add("header-plug_opened");
          header.classList.add("header_fixed");
          headerTop.classList.add("header-top_fixed");
        }
      } else {
        header.classList.remove("header_expanded");
        headerOpenImg.classList.add("header__hamburger-img_visible");
        headerCloseImg.classList.remove("header__close-img_visible");
        headerHamburger.setAttribute("aria-expanded", false);
        setTimeout(() => {
          header.classList.remove("header_fixed");
          headerTop.classList.remove("header-top_fixed");
          headerPlug.classList.remove("header-plug_opened");
        }, 300);
      }

      Shadow.toggleShadow();
    });

    shadowElement.addEventListener("click", () => {
      Shadow.toggleShadow();
      header.classList.remove("header_expanded");
      headerOpenImg.classList.add("header__hamburger-img_visible");
      headerCloseImg.classList.remove("header__close-img_visible");
      setTimeout(() => {
        header.classList.remove("header_fixed");
        headerTop.classList.remove("header-top_fixed");
        headerPlug.classList.remove("header-plug_opened");
      }, 300);
    });

    window.addEventListener("scroll", () => {
      if (window.scrollY > 53) {
        header.classList.add("header_scrolled");
      } else {
        header.classList.remove("header_scrolled");
      }
    });
  }
}

export const Header = new HeaderClass();
